"use client"

import { useMountAdcell } from "src/integrations/adcell/state"
import { ResolvedProductData } from "../../components/product-details/useResolvedProductData"
import { IntegrationScript } from "../lib/IntegrationScript"
import { adcellPid } from "./constants"

export type AdcellCategoryTagProps = {
  product: ResolvedProductData
}

export const AdcellProductTag = ({ product }: AdcellCategoryTagProps) => {
  const mountAdcell = useMountAdcell()

  if (!mountAdcell) {
    return null
  }

  const productId = product.resolvedSku
  const variationName = product.variation?.name
  const productName = product.name + (variationName ? ` (${variationName})` : "")
  const categoryId = product.categories?.[0]?.handle?.toLowerCase()
  const productIds = product.variations?.map((variation) => variation.sku).sort() || [product.sku]

  const src = `https://t.adcell.com/js/inlineretarget.js?method=product
&pid=${adcellPid}&productId=${productId}&productName=${productName}
&categoryId=${categoryId}&productIds=${productIds.join(",")}&productSeparator=,`

  return <IntegrationScript id="adcell_product" src={src} />
}
